import React, {Fragment} from "react"
import {useCatalog, useMessage, useModal, useSolution, useLocal, useHelp, useLightbox} from "../AppContext"
import {Modal} from "../Components/Modal"
import {Info} from "./Solution/Info"
import {Button} from "../Components/Button"
import {MODAL__SOLUTION_PRODUCTS} from "../Hooks/Modal"
import {productWireSkus} from "../settings"
import {iconBin, iconEye, iconFocus, iconInfo, iconPlus2, iconGallery} from "../Helper/Icons"
import style from "./SolutionProducts.css"

export const SolutionProducts = ({setProduct}) => {
    const local = useLocal()

    return <Modal type={MODAL__SOLUTION_PRODUCTS} tile={local.__("Absorber im Projektraum")} userStyle={{width: "800px"}}>
        <div className={style.layout}>
            <div>
                <Info title={local.__("Absorber in Ihrem Projektraum")} encouragement={local.__("Hier finden Sie alle Schallabsorber, die in Ihrer Raumplanung enthalten sind. Über die verschiedenen Symbole können Sie ausgeblendete Absorber erneut einblenden, Absorber ins Sichtfeld der Kamera holen, weitere Packeinheiten bereits ausgewählter Absorber hinzufügen oder Elemente endgültig aus Ihrer Planung entfernen.")} />
                <Items setProduct={setProduct}/>
            </div>
            <Footer/>
        </div>
    </Modal>
}

const Items = ({setProduct}) => {
    const solution = useSolution()
    const items = solution.getItems().filter(item => {
        return !productWireSkus.includes(item.parentSku)
    })

    return items.map((item, index) => <Item key={index} item={item} setProduct={setProduct}/>)
}

const Item = ({item, setProduct}) => {
    const catalog = useCatalog()
    const modal = useModal()
    const solution = useSolution()
    const local = useLocal()
    const messenger = useMessage()
    const help = useHelp()
    const parentProduct = catalog.getParentProduct(item.parentSku)
    const variantProduct = catalog.getVariantProduct(item.parentSku, item.sku)
    const options = catalog.getVariantOptions(item.parentSku, item.sku)
    const hasHiddenElements = solution.itemHasHiddenElements(item.id)
    const lightbox = useLightbox()

    const onShow = () => {
        solution.itemUnhiddenElements(item.id)
    }

    const onFocus = () => {
        solution.focusSet(item.id)
        modal.close()
    }

    const onAdd = () => {
        solution.increaseProductQty(item.id)
    }

    const onRemove = () => {
        const remove = () => {
            solution.itemRemove(item.id)
        }
        messenger.showPrompt(local.__("Möchten Sie die Elemete entfernen?"), remove)
    }

    const showInfo = () => {
        help.setContextOnce('projektraum-auge')
        modal.openHelp()
    }

    return <div className={style.item}>
        <div className={style.imageContainer} onClick={() => {setProduct(parentProduct); lightbox.openGallery();}}>
            <div className={style.image} style={{backgroundImage: `url('${parentProduct.imageUrl}')`}}/>
            <div className={style.galleryIcon}>{iconGallery}</div>
        </div>
        <div className={style.qty}>{item.quantity}x</div>
        <div>
            <div className={style.name}>{parentProduct.name}</div>
            <div className={style.options}>
                <div>{local.__("SKU")}:</div>
                <div>{variantProduct.sku}</div>
                {options.map((option, index) => <Fragment key={index}>
                    <div>{option.attributeLabel}:</div>
                    <div>{option.valueLabel}</div>
                </Fragment>)}
            </div>
        </div>
        <div className={style.action}>
            <div>
                <div className={style.iconLabel}>
                    <div onClick={showInfo}>{iconInfo}</div>
                    {local.__("einblenden")}
                </div>
                <Button onClick={onShow} isDisabled={!hasHiddenElements}>{iconEye}</Button>
            </div>
            <div>
                {local.__("sichtfeld")}
                <Button onClick={onFocus}>{iconFocus}</Button>
            </div>
            <div>
                {local.__("hinzufügen")}
                <Button onClick={onAdd}>{iconPlus2}</Button>
            </div>
            <div>
                {local.__("lösche")}
                <Button onClick={onRemove}>{iconBin}</Button>
            </div>
        </div>
    </div>
}

const Footer = () => {
    return <div className={style.footer}/>
}